/**
 * Listen navigation events and send pageView analytics.
 * See: https://nextjs.org/docs/app/api-reference/functions/use-router#router-events
 */
'use client';

import { useEffect, useRef } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import * as analytics from '@/analytics';

export function TrackPageView() {
  const pathname = usePathname();
  const searchParams = useSearchParams()?.toString();
  const firstRender = useRef(true);

  const url = `${pathname}?${searchParams}`;

  useEffect(() => {
    // Don't send page view on the first render, b/c snippet sends it on init.
    // See: https://github.com/microsoft/ApplicationInsights-JS/issues/2202
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    analytics.trackPageViewDebounce();
  }, [url]);

  return null;
}
